import { Divider, Form } from 'antd';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from 'react-intl';

import { useCreateNcm } from '@/core/domain/operational/Ncm/Ncm.hooks';

import { PageProps } from '@/types/PageProps';

import NcmOutgoingForm from '@/components/Fiscal/Ncm/NcmForm/NcmOutgoingForm';
import NcmIncomingForm from '@/components/Fiscal/Ncm/NcmForm/NcmIncomingForm';
import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { CreateNcmRequest } from '@/core/domain/operational/Ncm/Ncm.types';

export default function CreateNcmPage({ route }: PageProps) {
  const intl = useIntl();
  const history = useHistory();
  const [form] = Form.useForm();

  const createNcm = useCreateNcm();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      const obj: CreateNcmRequest = {
        active: true,
        ...values,
      };

      const result = await createNcm.mutateAsync(obj);

      history.push(`/app/fiscal/ncm/${result.id}`);
    } catch {}
  };

  return (
    <TabContentWrapper
      title={route.name}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSaveClick}
          loading={createNcm.isLoading}
        >
          <FormattedMessage id="commons.entity.save" />
        </SaveButton>
      }
    >
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <NcmOutgoingForm form={form} />

      <NcmIncomingForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/fiscal/ncm" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}
